import './Tools.css';

import React from 'react';
import Menu from '../../components/HamburgerMenu';
import img_map from './Tools_Fullscreen1_2x.png';

function Tools() {
  const handleExternalLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
    window.gtag('event', url);
  };

  return (
    <div className="page">
      <Menu />
      <div className="image-container">
        <img className="single-giant-page" src={img_map} alt="Tools" />
        
        {/* Hotspot 1 - Insights Garage / Amazon Marketing Cloud */}
        <div 
          className="hotspot hotspot-1"
          onClick={() => handleExternalLink('https://advertising.amazon.com/solutions/products/amazon-marketing-cloud')}
        />
        
        {/* Hotspot 2 - Autoreel Racer / Video Generator */}
        <div 
          className="hotspot hotspot-2"
          onClick={() => handleExternalLink('https://advertising.amazon.com/library/guides/ai-video-generator/')}
        />
        
        {/* Hotspot 3 - Agentic Accelerator / Amazon Ads AI */}
        <div 
          className="hotspot hotspot-3"
          onClick={() => handleExternalLink('https://aistudio.amazon.com/waitlist')}
        />
      </div>
    </div>
  );
}


export default Tools;
